'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Small = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Small = exports.Small = (0, _components2.default)({
  is: 'small',
  extend: _Text2.default,
  fontSize: 0
});

Small.displayName = 'Small';

exports.default = Small;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Small.js
// module id = 151
// module chunks = 22676092666560 46504955462500 107818501498521 221374088121123